import {Component, OnInit} from '@angular/core';
import {GlobalMessagesService} from '../../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';
import {Subject} from 'rxjs';
import {ConfirmationService} from 'primeng/api';
import {OrganizationTypeGetResponse} from '../../shared/types/organization/organization-type-get-response';
import {AddOrganizationTypeService} from '../../shared/services/oganization/add-organization-type.service';
import {ENTRY_STATES} from '../../shared/types/entry/EntryStatesEnum';
import {OrganizationType} from '../../shared/types/organization/organization-type';
import {OrganizationTypeRestService} from '../../shared/services/oganization/organization-type-rest.service';
import {Locale} from '../../shared/types/localization/locale';
import {SecurityService} from '../../shared/services/security/security.service';
import * as _ from 'lodash';
import {debounceTime} from 'rxjs/operators';

@Component({
  selector: 'wsd-organization-type',
  templateUrl: './organization-type.component.html',
  styleUrls: ['./organization-type.component.css']
})
export class OrganizationTypeComponent implements OnInit {

  organizationTypes: OrganizationTypeGetResponse;

  searchChanged = new Subject<void>();

  currentLocaleCode: string;

  filter = {
    name: ''
  };

  pageSize: number = 10;

  constructor(private organizationService: OrganizationTypeRestService,
              private message: GlobalMessagesService,
              private translate: TranslateService,
              private securityService: SecurityService,
              private confirmService: ConfirmationService,
              private addService: AddOrganizationTypeService) {
  }

  ngOnInit() {
    this.searchChanged.pipe(
      debounceTime(500)
    ).subscribe(() => this.loadData(0));

    this.securityService.getCurrentLocale().subscribe(
      (locale: Locale) => this.currentLocaleCode = locale.code
    );
  }

  getTranslatedName(names) {
    const translateName = names.find(name => name.langCode === this.currentLocaleCode);
    return translateName && translateName.value;
  }

  onPageChange(event) {
    this.loadData(event.first / event.rows);
  }

  private loadData(page: number) {
    this.organizationService.search(this.pageSize, page, this.filter.name).subscribe(
      (data: OrganizationTypeGetResponse) => this.organizationTypes = data
    );
  }

  modify(organizationType) {
    const organizationTypeClone = _.cloneDeep(organizationType);
    this.addService.modify(organizationTypeClone);
  }

  create() {
    this.addService.create();
  }

  search() {
    this.searchChanged.next();
  }

  onSave(event) {
    if (event.$state === ENTRY_STATES.NEW) {
      this.organizationService.create(event).subscribe(
        () => {
          this.loadData(0);
          this.message.showSuccessMessage(this.translate.instant('WS_DIRECTORY.ORGANIZATION_TYPE.SAVED_MESSAGE'));
        },
        () => this.message.showErrorMessage(this.translate.instant('WS_DIRECTORY.ORGANIZATION_TYPE.SAVE_ERROR_MESSAGE'))
      );
    } else {
      this.organizationService.update(event).subscribe(
        (organizationType: OrganizationType) => {
          this.organizationTypes.content.forEach(
            entry => {
              if (entry.id === organizationType.id) {
                this.organizationTypes.content[this.organizationTypes.content.indexOf(entry)] = organizationType;
              }
            }
          );
          this.message.showSuccessMessage(this.translate.instant('WS_DIRECTORY.ORGANIZATION_TYPE.SAVED_MESSAGE'));
        },
        () => this.message.showErrorMessage(this.translate.instant('WS_DIRECTORY.ORGANIZATION_TYPE.SAVE_ERROR_MESSAGE'))
      );
    }
  }

  confirmDelete(organizationType: OrganizationType) {
    this.confirmService.confirm({
      header: this.translate.instant('WS_DIRECTORY.ORGANIZATION_TYPE.CONFIRM_HEADER'),
      message: this.translate.instant('WS_DIRECTORY.ORGANIZATION_TYPE.CONFIRM_MESSAGE'),
      accept: () => this.delete(organizationType)
    });
  }

  private delete(organizationType: OrganizationType) {
    this.organizationService.delete(organizationType).subscribe(
      () => {
        this.organizationTypes.content.splice(this.organizationTypes.content.indexOf(organizationType), 1);
        this.message.showSuccessMessage(this.translate.instant('WS_DIRECTORY.ORGANIZATION_TYPE.DELETED_MESSAGE'));
      },
      () => this.message.showErrorMessage(this.translate.instant('WS_DIRECTORY.ORGANIZATION_TYPE.REMOVAL_ERROR_MESSAGE'))
    );
  }

}
